const Earning = {
  Conversion: "conversion",
  PayWithPoints: "pay-with-points",
  LOCQPay: "locqpay",
  PayWithLiters: "pay-with-points",
};

export default Earning;
